export let SourceType = /*#__PURE__*/function (SourceType) {
  SourceType["BASE64"] = "base64";
  SourceType["EPUB"] = "epub";
  SourceType["OPF"] = "opf";
  SourceType["BINARY"] = "binary";
  return SourceType;
}({});